/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from '@angular/core';
import { Client, generateClient, GraphQLResult } from 'aws-amplify/api';
import { Observable } from 'rxjs';

export type __SubscriptionContainer = {
  onCreateCompany: OnCreateCompanySubscription;
  onUpdateCompany: OnUpdateCompanySubscription;
  onDeleteCompany: OnDeleteCompanySubscription;
  onCreateUserDetails: OnCreateUserDetailsSubscription;
  onUpdateUserDetails: OnUpdateUserDetailsSubscription;
  onDeleteUserDetails: OnDeleteUserDetailsSubscription;
  onCreateCompanyDetails: OnCreateCompanyDetailsSubscription;
  onUpdateCompanyDetails: OnUpdateCompanyDetailsSubscription;
  onDeleteCompanyDetails: OnDeleteCompanyDetailsSubscription;
};

export type CreateCompanyInput = {
  id?: string | null;
  companyName: string;
  companyType: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  country: string;
};

export type ModelCompanyConditionInput = {
  companyName?: ModelStringInput | null;
  companyType?: ModelStringInput | null;
  country?: ModelStringInput | null;
  vatNumber?: ModelStringInput | null;
  businessSector?: ModelStringInput | null;
  address?: ModelStringInput | null;
  status?: ModelStringInput | null;
  contactPhone?: ModelStringInput | null;
  contactEmail?: ModelStringInput | null;
  isFavorite?: ModelBooleanInput | null;
  companyLogo?: ModelStringInput | null;
  userId?: ModelIDInput | null;
  and?: Array<ModelCompanyConditionInput | null> | null;
  or?: Array<ModelCompanyConditionInput | null> | null;
  not?: ModelCompanyConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = 'binary',
  binarySet = 'binarySet',
  bool = 'bool',
  list = 'list',
  map = 'map',
  number = 'number',
  numberSet = 'numberSet',
  string = 'string',
  stringSet = 'stringSet',
  _null = '_null',
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type Company = {
  __typename: 'Company';
  id: string;
  companyName: string;
  country: string;
  companyType: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCompanyInput = {
  id: string;
  companyName?: string | null;
  companyType?: string | null;
  vatNumber?: string | null;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId?: string | null;
  country?: string | null;
};

export type DeleteCompanyInput = {
  id: string;
};

export type CreateUserDetailsInput = {
  id?: string | null;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  otherBusinessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
};

export type ModelUserDetailsConditionInput = {
  userID?: ModelIDInput | null;
  name?: ModelStringInput | null;
  surname?: ModelStringInput | null;
  phoneNumber?: ModelStringInput | null;
  companyRole?: ModelStringInput | null;
  companyName?: ModelStringInput | null;
  vatNumber?: ModelStringInput | null;
  address?: ModelStringInput | null;
  businessSector?: ModelStringInput | null;
  numberOfEmployees?: ModelIntInput | null;
  subscriptionPlan?: ModelStringInput | null;
  profilePhoto?: ModelStringInput | null;
  pec?: ModelStringInput | null;
  legalRepresentative?: ModelStringInput | null;
  and?: Array<ModelUserDetailsConditionInput | null> | null;
  or?: Array<ModelUserDetailsConditionInput | null> | null;
  not?: ModelUserDetailsConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type UserDetails = {
  __typename: 'UserDetails';
  id: string;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  otherBusinessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateUserDetailsInput = {
  id: string;
  userID?: string | null;
  name?: string | null;
  surname?: string | null;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName?: string | null;
  vatNumber?: string | null;
  address?: string | null;
  businessSector?: string | null;
  otherBusinessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
};

export type DeleteUserDetailsInput = {
  id: string;
};

export type CreateCompanyDetailsInput = {
  id?: string | null;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  report?: string | null;
};

export type ModelCompanyDetailsConditionInput = {
  companyId?: ModelIDInput | null;
  calculationName?: ModelStringInput | null;
  paidForLogo?: ModelBooleanInput | null;
  paidForReport?: ModelBooleanInput | null;
  startDate?: ModelStringInput | null;
  answers?: ModelStringInput | null;
  and?: Array<ModelCompanyDetailsConditionInput | null> | null;
  or?: Array<ModelCompanyDetailsConditionInput | null> | null;
  not?: ModelCompanyDetailsConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type companyDetails = {
  __typename: 'companyDetails';
  id: string;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCompanyDetailsInput = {
  id: string;
  companyId?: string | null;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  report?: string | null;
};

export type DeleteCompanyDetailsInput = {
  id: string;
};

// Invite types
export type CreateInviteInput = {
  id?: string | null;
  userId: string;
  companyId: string;
  inviteeEmail: string;
  inviterEmail: string;
  associatedCompanies?: Array<string | null> | null;
  status: string;
  statusUpdatedAt?: string | null;
};

export type ModelInviteConditionInput = {
  userId?: ModelIDInput | null;
  companyId?: ModelIDInput | null;
  inviteeEmail?: ModelStringInput | null;
  associatedCompanies?: ModelStringInput | null;
  status?: ModelStringInput | null;
  statusUpdatedAt?: ModelStringInput | null;
  and?: Array<ModelInviteConditionInput | null> | null;
  or?: Array<ModelInviteConditionInput | null> | null;
  not?: ModelInviteConditionInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
};

export type Invite = {
  __typename: 'Invite';
  id: string;
  userId: string;
  companyId: string;
  inviteeEmail: string;
  inviterEmail?: string | null;
  associatedCompanies?: Array<string | null> | null;
  status: string;
  statusUpdatedAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateInviteInput = {
  id: string;
  userId?: string | null;
  companyId?: string | null;
  inviteeEmail?: string | null;
  associatedCompanies?: Array<string | null> | null;
  status?: string | null;
  statusUpdatedAt?: string | null;
};

export type DeleteInviteInput = {
  id: string;
};

export type ModelInviteFilterInput = {
  id?: ModelIDInput | null;
  userId?: ModelIDInput | null;
  companyId?: ModelIDInput | null;
  inviteeEmail?: ModelStringInput | null;
  associatedCompanies?: ModelStringInput | null;
  status?: ModelStringInput | null;
  statusUpdatedAt?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelInviteFilterInput | null> | null;
  or?: Array<ModelInviteFilterInput | null> | null;
  not?: ModelInviteFilterInput | null;
};

export type ModelInviteConnection = {
  __typename: 'ModelInviteConnection';
  items: Array<Invite | null>;
  nextToken?: string | null;
};

export type CreateInviteMutation = {
  __typename: 'Invite';
  id: string;
  userId: string;
  companyId: string;
  inviteeEmail: string;
  inviterEmail?: string | null;
  associatedCompanies?: Array<string | null> | null;
  status: string;
  statusUpdatedAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateInviteMutation = {
  __typename: 'Invite';
  id: string;
  userId: string;
  companyId: string;
  inviteeEmail: string;
  inviterEmail?: string | null;
  associatedCompanies?: Array<string | null> | null;
  status: string;
  statusUpdatedAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteInviteMutation = {
  __typename: 'Invite';
  id: string;
  userId: string;
  companyId: string;
  inviteeEmail: string;
  inviterEmail?: string | null;
  associatedCompanies?: Array<string | null> | null;
  status: string;
  statusUpdatedAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type GetInviteQuery = {
  __typename: 'Invite';
  id: string;
  userId: string;
  companyId: string;
  inviteeEmail: string;
  inviterEmail?: string | null;
  associatedCompanies?: Array<string | null> | null;
  status: string;
  statusUpdatedAt?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListInvitesQuery = {
  __typename: 'ModelInviteConnection';
  items: Array<{
    __typename: 'Invite';
    id: string;
    userId: string;
    companyId: string;
    inviteeEmail: string;
    inviterEmail?: string | null;
    associatedCompanies?: Array<string | null> | null;
    status: string;
    statusUpdatedAt?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type InvitesByUserIdQuery = {
  __typename: 'ModelInviteConnection';
  items: Array<{
    __typename: 'Invite';
    id: string;
    userId: string;
    companyId: string;
    inviteeEmail: string;
    inviterEmail?: string | null;
    associatedCompanies?: Array<string | null> | null;
    status: string;
    statusUpdatedAt?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type InvitesByCompanyIdQuery = {
  __typename: 'ModelInviteConnection';
  items: Array<{
    __typename: 'Invite';
    id: string;
    userId: string;
    companyId: string;
    inviteeEmail: string;
    inviterEmail?: string | null;
    associatedCompanies?: Array<string | null> | null;
    status: string;
    statusUpdatedAt?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type InvitesByInviteeEmailQuery = {
  __typename: 'ModelInviteConnection';
  items: Array<{
    __typename: 'Invite';
    id: string;
    userId: string;
    companyId: string;
    inviteeEmail: string;
    inviterEmail?: string | null;
    associatedCompanies?: Array<string | null> | null;
    status: string;
    statusUpdatedAt?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ModelCompanyFilterInput = {
  id?: ModelIDInput | null;
  companyName?: ModelStringInput | null;
  companyType?: ModelStringInput | null;
  country?: ModelStringInput | null;
  vatNumber?: ModelStringInput | null;
  businessSector?: ModelStringInput | null;
  address?: ModelStringInput | null;
  status?: ModelStringInput | null;
  contactPhone?: ModelStringInput | null;
  contactEmail?: ModelStringInput | null;
  isFavorite?: ModelBooleanInput | null;
  companyLogo?: ModelStringInput | null;
  userId?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelCompanyFilterInput | null> | null;
  or?: Array<ModelCompanyFilterInput | null> | null;
  not?: ModelCompanyFilterInput | null;
};

export type ModelCompanyConnection = {
  __typename: 'ModelCompanyConnection';
  items: Array<Company | null>;
  nextToken?: string | null;
};

export type ModelUserDetailsFilterInput = {
  id?: ModelIDInput | null;
  userID?: ModelIDInput | null;
  name?: ModelStringInput | null;
  surname?: ModelStringInput | null;
  phoneNumber?: ModelStringInput | null;
  companyRole?: ModelStringInput | null;
  companyName?: ModelStringInput | null;
  vatNumber?: ModelStringInput | null;
  address?: ModelStringInput | null;
  businessSector?: ModelStringInput | null;
  numberOfEmployees?: ModelIntInput | null;
  subscriptionPlan?: ModelStringInput | null;
  profilePhoto?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelUserDetailsFilterInput | null> | null;
  or?: Array<ModelUserDetailsFilterInput | null> | null;
  not?: ModelUserDetailsFilterInput | null;
};

export type ModelUserDetailsConnection = {
  __typename: 'ModelUserDetailsConnection';
  items: Array<UserDetails | null>;
  nextToken?: string | null;
};

export type ModelCompanyDetailsFilterInput = {
  id?: ModelIDInput | null;
  companyId?: ModelIDInput | null;
  calculationName?: ModelStringInput | null;
  paidForLogo?: ModelBooleanInput | null;
  paidForReport?: ModelBooleanInput | null;
  startDate?: ModelStringInput | null;
  answers?: ModelStringInput | null;
  createdAt?: ModelStringInput | null;
  updatedAt?: ModelStringInput | null;
  and?: Array<ModelCompanyDetailsFilterInput | null> | null;
  or?: Array<ModelCompanyDetailsFilterInput | null> | null;
  not?: ModelCompanyDetailsFilterInput | null;
};

export type ModelCompanyDetailsConnection = {
  __typename: 'ModelCompanyDetailsConnection';
  items: Array<companyDetails | null>;
  nextToken?: string | null;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type ModelcompanyDetailsFilterInput = {
  id?: ModelIDInput | null;
  companyId?: ModelIDInput | null;
  calculationName?: ModelStringInput | null;
  paidForLogo?: ModelBooleanInput | null;
  paidForReport?: ModelBooleanInput | null;
  startDate?: ModelStringInput | null;
  answers?: ModelStringInput | null;
  and?: Array<ModelcompanyDetailsFilterInput | null> | null;
  or?: Array<ModelcompanyDetailsFilterInput | null> | null;
  not?: ModelcompanyDetailsFilterInput | null;
};

export type ModelcompanyDetailsConnection = {
  __typename: 'ModelcompanyDetailsConnection';
  items: Array<companyDetails | null>;
  nextToken?: string | null;
};

export type ModelSubscriptionCompanyFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  companyName?: ModelSubscriptionStringInput | null;
  companyType?: ModelSubscriptionStringInput | null;
  country?: ModelSubscriptionStringInput | null;
  vatNumber?: ModelSubscriptionStringInput | null;
  businessSector?: ModelSubscriptionStringInput | null;
  address?: ModelSubscriptionStringInput | null;
  status?: ModelSubscriptionStringInput | null;
  contactPhone?: ModelSubscriptionStringInput | null;
  contactEmail?: ModelSubscriptionStringInput | null;
  isFavorite?: ModelSubscriptionBooleanInput | null;
  companyLogo?: ModelSubscriptionStringInput | null;
  userId?: ModelSubscriptionIDInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionCompanyFilterInput | null> | null;
  or?: Array<ModelSubscriptionCompanyFilterInput | null> | null;
};

export type ModelSubscriptionIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
};

export type ModelSubscriptionUserDetailsFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  userID?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  surname?: ModelSubscriptionStringInput | null;
  phoneNumber?: ModelSubscriptionStringInput | null;
  companyRole?: ModelSubscriptionStringInput | null;
  companyName?: ModelSubscriptionStringInput | null;
  vatNumber?: ModelSubscriptionStringInput | null;
  address?: ModelSubscriptionStringInput | null;
  businessSector?: ModelSubscriptionStringInput | null;
  numberOfEmployees?: ModelSubscriptionIntInput | null;
  subscriptionPlan?: ModelSubscriptionStringInput | null;
  profilePhoto?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionUserDetailsFilterInput | null> | null;
  or?: Array<ModelSubscriptionUserDetailsFilterInput | null> | null;
};

export type ModelSubscriptionIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionCompanyDetailsFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  companyId?: ModelSubscriptionIDInput | null;
  calculationName?: ModelSubscriptionStringInput | null;
  paidForLogo?: ModelSubscriptionBooleanInput | null;
  paidForReport?: ModelSubscriptionBooleanInput | null;
  startDate?: ModelSubscriptionStringInput | null;
  answers?: ModelSubscriptionStringInput | null;
  createdAt?: ModelSubscriptionStringInput | null;
  updatedAt?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionCompanyDetailsFilterInput | null> | null;
  or?: Array<ModelSubscriptionCompanyDetailsFilterInput | null> | null;
};

export type CreateCompanyMutation = {
  __typename: 'Company';
  id: string;
  companyName: string;
  companyType: string;
  country: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCompanyMutation = {
  __typename: 'Company';
  id: string;
  companyName: string;
  companyType: string;
  country: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
};

export type DeleteCompanyMutation = {
  __typename: 'Company';
  id: string;
  companyName: string;
  companyType: string;
  country: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
};

export type CreateUserDetailsMutation = {
  __typename: 'UserDetails';
  id: string;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateUserDetailsMutation = {
  __typename: 'UserDetails';
  id: string;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteUserDetailsMutation = {
  __typename: 'UserDetails';
  id: string;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateCompanyDetailsMutation = {
  __typename: 'companyDetails';
  id: string;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCompanyDetailsMutation = {
  __typename: 'companyDetails';
  id: string;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteCompanyDetailsMutation = {
  __typename: 'companyDetails';
  id: string;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type GetCompanyQuery = {
  __typename: 'Company';
  id: string;
  companyName: string;
  companyType: string;
  country: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
};

export type ListCompaniesQuery = {
  __typename: 'ModelCompanyConnection';
  items: Array<{
    __typename: 'Company';
    id: string;
    companyName: string;
    companyType: string;
    country: string;
    vatNumber: string;
    businessSector?: string | null;
    address?: string | null;
    status?: string | null;
    contactPhone?: string | null;
    contactEmail?: string | null;
    isFavorite?: boolean | null;
    companyLogo?: string | null;
    userId: string;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetUserDetailsQuery = {
  __typename: 'UserDetails';
  id: string;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListUserDetailsQuery = {
  __typename: 'ModelUserDetailsConnection';
  items: Array<{
    __typename: 'UserDetails';
    id: string;
    userID: string;
    name: string;
    surname: string;
    phoneNumber?: string | null;
    companyRole?: string | null;
    companyName: string;
    vatNumber: string;
    address?: string | null;
    businessSector?: string | null;
    numberOfEmployees?: number | null;
    subscriptionPlan?: string | null;
    profilePhoto?: string | null;
    pec?: string | null;
    legalRepresentative?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetCompanyDetailsQuery = {
  __typename: 'companyDetails';
  id: string;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  report?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListCompanyDetailsQuery = {
  __typename: 'ModelCompanyDetailsConnection';
  items: Array<{
    __typename: 'companyDetails';
    id: string;
    companyId: string;
    calculationName?: string | null;
    paidForLogo?: boolean | null;
    paidForReport?: boolean | null;
    startDate?: string | null;
    answers?: string | null;
    report?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type CompaniesByUserIdQuery = {
  __typename: 'ModelCompanyConnection';
  items: Array<{
    __typename: 'Company';
    id: string;
    companyName: string;
    companyType: string;
    country: string;
    vatNumber: string;
    businessSector?: string | null;
    address?: string | null;
    status?: string | null;
    contactPhone?: string | null;
    contactEmail?: string | null;
    isFavorite?: boolean | null;
    companyLogo?: string | null;
    userId: string;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type CompanyDetailsByCompanyIdQuery = {
  __typename: 'ModelcompanyDetailsConnection';
  items: Array<{
    __typename: 'companyDetails';
    id: string;
    companyId: string;
    calculationName?: string | null;
    paidForLogo?: boolean | null;
    paidForReport?: boolean | null;
    startDate?: string | null;
    answers?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type OnCreateCompanySubscription = {
  __typename: 'Company';
  id: string;
  companyName: string;
  companyType: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
  country: string;
};

export type OnUpdateCompanySubscription = {
  __typename: 'Company';
  id: string;
  companyName: string;
  companyType: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
  country: string;
};

export type OnDeleteCompanySubscription = {
  __typename: 'Company';
  id: string;
  companyName: string;
  companyType: string;
  vatNumber: string;
  businessSector?: string | null;
  address?: string | null;
  status?: string | null;
  contactPhone?: string | null;
  contactEmail?: string | null;
  isFavorite?: boolean | null;
  companyLogo?: string | null;
  userId: string;
  createdAt: string;
  updatedAt: string;
  country: string;
};

export type OnCreateUserDetailsSubscription = {
  __typename: 'UserDetails';
  id: string;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateUserDetailsSubscription = {
  __typename: 'UserDetails';
  id: string;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteUserDetailsSubscription = {
  __typename: 'UserDetails';
  id: string;
  userID: string;
  name: string;
  surname: string;
  phoneNumber?: string | null;
  companyRole?: string | null;
  companyName: string;
  vatNumber: string;
  address?: string | null;
  businessSector?: string | null;
  numberOfEmployees?: number | null;
  subscriptionPlan?: string | null;
  profilePhoto?: string | null;
  pec?: string | null;
  legalRepresentative?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateCompanyDetailsSubscription = {
  __typename: 'companyDetails';
  id: string;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateCompanyDetailsSubscription = {
  __typename: 'companyDetails';
  id: string;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteCompanyDetailsSubscription = {
  __typename: 'companyDetails';
  id: string;
  companyId: string;
  calculationName?: string | null;
  paidForLogo?: boolean | null;
  paidForReport?: boolean | null;
  startDate?: string | null;
  answers?: string | null;
  createdAt: string;
  updatedAt: string;
};

@Injectable({
  providedIn: 'root',
})
export class APIService {
  public client: Client;
  constructor() {
    // @ts-ignore
    this.client = generateClient({ authMode: 'userPool' });
  }
  async CreateCompany(
    input: CreateCompanyInput,
    condition?: ModelCompanyConditionInput,
  ): Promise<CreateCompanyMutation> {
    const statement = `mutation CreateCompany($input: CreateCompanyInput!, $condition: ModelCompanyConditionInput) {
        createCompany(input: $input, condition: $condition) {
          __typename
          id
          companyName
          companyType
          vatNumber
          businessSector
          address
          status
          contactPhone
          contactEmail
          isFavorite
          companyLogo
          userId
          createdAt
          updatedAt
          country
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <CreateCompanyMutation>response.data.createCompany;
  }
  async UpdateCompany(
    input: UpdateCompanyInput,
    condition?: ModelCompanyConditionInput,
  ): Promise<UpdateCompanyMutation> {
    const statement = `mutation UpdateCompany($input: UpdateCompanyInput!, $condition: ModelCompanyConditionInput) {
        updateCompany(input: $input, condition: $condition) {
          __typename
          id
          companyName
          companyType
          vatNumber
          businessSector
          address
          status
          contactPhone
          country
          contactEmail
          isFavorite
          companyLogo
          userId
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <UpdateCompanyMutation>response.data.updateCompany;
  }
  async DeleteCompany(
    input: DeleteCompanyInput,
    condition?: ModelCompanyConditionInput,
  ): Promise<DeleteCompanyMutation> {
    const statement = `mutation DeleteCompany($input: DeleteCompanyInput!, $condition: ModelCompanyConditionInput) {
        deleteCompany(input: $input, condition: $condition) {
          __typename
          id
          companyName
          companyType
          vatNumber
          businessSector
          address
          status
          contactPhone
          contactEmail
          isFavorite
          companyLogo
          userId
          createdAt
          updatedAt
          country
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <DeleteCompanyMutation>response.data.deleteCompany;
  }
  async CreateUserDetails(
    input: CreateUserDetailsInput,
    condition?: ModelUserDetailsConditionInput,
  ): Promise<CreateUserDetailsMutation> {
    const statement = `mutation CreateUserDetails($input: CreateUserDetailsInput!, $condition: ModelUserDetailsConditionInput) {
        createUserDetails(input: $input, condition: $condition) {
          __typename
          id
          userID
          name
          surname
          phoneNumber
          companyRole
          companyName
          vatNumber
          address
          businessSector
          otherBusinessSector
          numberOfEmployees
          subscriptionPlan
          profilePhoto
          pec
          legalRepresentative
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <CreateUserDetailsMutation>response.data.createUserDetails;
  }
  async UpdateUserDetails(
    input: UpdateUserDetailsInput,
    condition?: ModelUserDetailsConditionInput,
  ): Promise<UpdateUserDetailsMutation> {
    const statement = `mutation UpdateUserDetails($input: UpdateUserDetailsInput!, $condition: ModelUserDetailsConditionInput) {
        updateUserDetails(input: $input, condition: $condition) {
          __typename
          id
          userID
          name
          surname
          phoneNumber
          companyRole
          companyName
          vatNumber
          address
          businessSector
          otherBusinessSector
          numberOfEmployees
          subscriptionPlan
          profilePhoto
          pec
          legalRepresentative
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <UpdateUserDetailsMutation>response.data.updateUserDetails;
  }
  async DeleteUserDetails(
    input: DeleteUserDetailsInput,
    condition?: ModelUserDetailsConditionInput,
  ): Promise<DeleteUserDetailsMutation> {
    const statement = `mutation DeleteUserDetails($input: DeleteUserDetailsInput!, $condition: ModelUserDetailsConditionInput) {
        deleteUserDetails(input: $input, condition: $condition) {
          __typename
          id
          userID
          name
          surname
          phoneNumber
          companyRole
          companyName
          vatNumber
          address
          businessSector
          numberOfEmployees
          subscriptionPlan
          profilePhoto
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <DeleteUserDetailsMutation>response.data.deleteUserDetails;
  }
  async CreateCompanyDetails(
    input: CreateCompanyDetailsInput,
    condition?: ModelCompanyDetailsConditionInput,
  ): Promise<CreateCompanyDetailsMutation> {
    const statement = `mutation CreateCompanyDetails($input: CreateCompanyDetailsInput!, $condition: ModelCompanyDetailsConditionInput) {
        createCompanyDetails(input: $input, condition: $condition) {
          __typename
          id
          companyId
          calculationName
          paidForLogo
          paidForReport
          startDate
          answers
          createdAt
          updatedAt
          report
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <CreateCompanyDetailsMutation>response.data.createCompanyDetails;
  }
  async UpdateCompanyDetails(
    input: UpdateCompanyDetailsInput,
    condition?: ModelCompanyDetailsConditionInput,
  ): Promise<UpdateCompanyDetailsMutation> {
    const statement = `mutation UpdateCompanyDetails($input: UpdateCompanyDetailsInput!, $condition: ModelCompanyDetailsConditionInput) {
        updateCompanyDetails(input: $input, condition: $condition) {
          __typename
          id
          companyId
          calculationName
          paidForLogo
          paidForReport
          startDate
          answers
          createdAt
          updatedAt
          report
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <UpdateCompanyDetailsMutation>response.data.updateCompanyDetails;
  }
  async DeleteCompanyDetails(
    input: DeleteCompanyDetailsInput,
    condition?: ModelCompanyDetailsConditionInput,
  ): Promise<DeleteCompanyDetailsMutation> {
    const statement = `mutation DeleteCompanyDetails($input: DeleteCompanyDetailsInput!, $condition: ModelCompanyDetailsConditionInput) {
        deleteCompanyDetails(input: $input, condition: $condition) {
          __typename
          id
          companyId
          calculationName
          paidForLogo
          paidForReport
          startDate
          answers
          createdAt
          updatedAt
          report
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <DeleteCompanyDetailsMutation>response.data.deleteCompanyDetails;
  }
  async GetCompany(id: string): Promise<GetCompanyQuery> {
    const statement = `query GetCompany($id: ID!) {
        getCompany(id: $id) {
          __typename
          id
          companyName
          companyType
          vatNumber
          businessSector
          address
          status
          contactPhone
          contactEmail
          isFavorite
          companyLogo
          userId
          createdAt
          country
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <GetCompanyQuery>response.data.getCompany;
  }
  async ListCompanies(
    filter?: ModelCompanyFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<ListCompaniesQuery> {
    const statement = `query ListCompanies($filter: ModelCompanyFilterInput, $limit: Int, $nextToken: String) {
        listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            companyName
            companyType
            vatNumber
            businessSector
            address
            status
            contactPhone
            contactEmail
            isFavorite
            companyLogo
            userId
            createdAt
            updatedAt
            country
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <ListCompaniesQuery>response.data.listCompanies;
  }
  async GetUserDetails(id: string): Promise<GetUserDetailsQuery> {
    const statement = `query GetUserDetails($id: ID!) {
        getUserDetails(id: $id) {
          __typename
          id
          userID
          name
          surname
          phoneNumber
          companyRole
          companyName
          vatNumber
          address
          businessSector
          numberOfEmployees
          subscriptionPlan
          profilePhoto
          pec
          legalRepresentative
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <GetUserDetailsQuery>response.data.getUserDetails;
  }
  async ListUserDetails(
    filter?: ModelUserDetailsFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<ListUserDetailsQuery> {
    const statement = `query ListUserDetails($filter: ModelUserDetailsFilterInput, $limit: Int, $nextToken: String) {
        listUserDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            userID
            name
            surname
            phoneNumber
            companyRole
            companyName
            vatNumber
            address
            businessSector
            otherBusinessSector
            numberOfEmployees
            subscriptionPlan
            profilePhoto
            pec
            legalRepresentative
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <ListUserDetailsQuery>response.data.listUserDetails;
  }
  async GetCompanyDetails(id: string): Promise<GetCompanyDetailsQuery> {
    const statement = `query GetCompanyDetails($id: ID!) {
        getCompanyDetails(id: $id) {
          __typename
          id
          companyId
          calculationName
          paidForLogo
          paidForReport
          startDate
          answers
          report
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <GetCompanyDetailsQuery>response.data.getCompanyDetails;
  }
  async ListCompanyDetails(
    filter?: ModelCompanyDetailsFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<ListCompanyDetailsQuery> {
    const statement = `query ListCompanyDetails($filter: ModelCompanyDetailsFilterInput, $limit: Int, $nextToken: String) {
        listCompanyDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            companyId
            calculationName
            paidForLogo
            paidForReport
            startDate
            answers
            report
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <ListCompanyDetailsQuery>response.data.listCompanyDetails;
  }
  async CompaniesByUserId(
    userId: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelCompanyFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<CompaniesByUserIdQuery> {
    const statement = `query CompaniesByUserId($userId: ID!, $sortDirection: ModelSortDirection, $filter: ModelCompanyFilterInput, $limit: Int, $nextToken: String) {
        companiesByUserId(
          userId: $userId
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            companyName
            companyType
            vatNumber
            businessSector
            address
            status
            contactPhone
            contactEmail
            isFavorite
            companyLogo
            userId
            createdAt
            updatedAt
            country
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userId,
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <CompaniesByUserIdQuery>response.data.companiesByUserId;
  }
  async CompanyDetailsByCompanyId(
    companyId: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelcompanyDetailsFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<CompanyDetailsByCompanyIdQuery> {
    const statement = `query CompanyDetailsByCompanyId($companyId: ID!, $sortDirection: ModelSortDirection, $filter: ModelcompanyDetailsFilterInput, $limit: Int, $nextToken: String) {
        companyDetailsByCompanyId(
          companyId: $companyId
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            companyId
            calculationName
            paidForLogo
            paidForReport
            startDate
            answers
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <CompanyDetailsByCompanyIdQuery>(
      response.data.companyDetailsByCompanyId
    );
  }
  OnCreateCompanyListener(
    filter?: ModelSubscriptionCompanyFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onCreateCompany'>>
  > {
    const statement = `subscription OnCreateCompany($filter: ModelSubscriptionCompanyFilterInput) {
        onCreateCompany(filter: $filter) {
          __typename
          id
          companyName
          companyType
          vatNumber
          businessSector
          address
          status
          country
          contactPhone
          contactEmail
          isFavorite
          companyLogo
          userId
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  OnUpdateCompanyListener(
    filter?: ModelSubscriptionCompanyFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onUpdateCompany'>>
  > {
    const statement = `subscription OnUpdateCompany($filter: ModelSubscriptionCompanyFilterInput) {
        onUpdateCompany(filter: $filter) {
          __typename
          id
          companyName
          companyType
          vatNumber
          businessSector
          address
          status
          contactPhone
          contactEmail
          isFavorite
          companyLogo
          userId
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  OnDeleteCompanyListener(
    filter?: ModelSubscriptionCompanyFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onDeleteCompany'>>
  > {
    const statement = `subscription OnDeleteCompany($filter: ModelSubscriptionCompanyFilterInput) {
        onDeleteCompany(filter: $filter) {
          __typename
          id
          companyName
          companyType
          vatNumber
          businessSector
          address
          status
          contactPhone
          contactEmail
          isFavorite
          companyLogo
          userId
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  OnCreateUserDetailsListener(
    filter?: ModelSubscriptionUserDetailsFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onCreateUserDetails'>>
  > {
    const statement = `subscription OnCreateUserDetails($filter: ModelSubscriptionUserDetailsFilterInput) {
        onCreateUserDetails(filter: $filter) {
          __typename
          id
          userID
          name
          surname
          phoneNumber
          companyRole
          companyName
          vatNumber
          address
          businessSector
          numberOfEmployees
          subscriptionPlan
          profilePhoto
          pec
          legalRepresentative
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  OnUpdateUserDetailsListener(
    filter?: ModelSubscriptionUserDetailsFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onUpdateUserDetails'>>
  > {
    const statement = `subscription OnUpdateUserDetails($filter: ModelSubscriptionUserDetailsFilterInput) {
        onUpdateUserDetails(filter: $filter) {
          __typename
          id
          userID
          name
          surname
          phoneNumber
          companyRole
          companyName
          vatNumber
          address
          businessSector
          numberOfEmployees
          subscriptionPlan
          profilePhoto
          pec
          legalRepresentative
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  OnDeleteUserDetailsListener(
    filter?: ModelSubscriptionUserDetailsFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onDeleteUserDetails'>>
  > {
    const statement = `subscription OnDeleteUserDetails($filter: ModelSubscriptionUserDetailsFilterInput) {
        onDeleteUserDetails(filter: $filter) {
          __typename
          id
          userID
          name
          surname
          phoneNumber
          companyRole
          companyName
          vatNumber
          address
          businessSector
          numberOfEmployees
          subscriptionPlan
          profilePhoto
          pec
          legalRepresentative
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  OnCreateCompanyDetailsListener(
    filter?: ModelSubscriptionCompanyDetailsFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onCreateCompanyDetails'>>
  > {
    const statement = `subscription OnCreateCompanyDetails($filter: ModelSubscriptionCompanyDetailsFilterInput) {
        onCreateCompanyDetails(filter: $filter) {
          __typename
          id
          companyId
          calculationName
          paidForLogo
          paidForReport
          startDate
          answers
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  OnUpdateCompanyDetailsListener(
    filter?: ModelSubscriptionCompanyDetailsFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onUpdateCompanyDetails'>>
  > {
    const statement = `subscription OnUpdateCompanyDetails($filter: ModelSubscriptionCompanyDetailsFilterInput) {
        onUpdateCompanyDetails(filter: $filter) {
          __typename
          id
          companyId
          calculationName
          paidForLogo
          paidForReport
          startDate
          answers
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  OnDeleteCompanyDetailsListener(
    filter?: ModelSubscriptionCompanyDetailsFilterInput,
  ): Observable<
    GraphQLResult<Pick<__SubscriptionContainer, 'onDeleteCompanyDetails'>>
  > {
    const statement = `subscription OnDeleteCompanyDetails($filter: ModelSubscriptionCompanyDetailsFilterInput) {
        onDeleteCompanyDetails(filter: $filter) {
          __typename
          id
          companyId
          calculationName
          paidForLogo
          paidForReport
          startDate
          answers
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    }) as any;
  }

  // Invite CRUD methods
  async CreateInvite(input: CreateInviteInput): Promise<CreateInviteMutation> {
    const statement = `mutation CreateInvite($input: CreateInviteInput!) {
        createInvite(input: $input) {
          __typename
          id
          userId
          companyId
          inviteeEmail
          inviterEmail
          associatedCompanies
          status
          statusUpdatedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <CreateInviteMutation>response.data.createInvite;
  }

  async UpdateInvite(input: UpdateInviteInput): Promise<UpdateInviteMutation> {
    const statement = `mutation UpdateInvite($input: UpdateInviteInput!) {
        updateInvite(input: $input) {
          __typename
          id
          userId
          companyId
          inviteeEmail
          inviterEmail
          associatedCompanies
          status
          statusUpdatedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <UpdateInviteMutation>response.data.updateInvite;
  }

  async DeleteInvite(input: DeleteInviteInput): Promise<DeleteInviteMutation> {
    const statement = `mutation DeleteInvite($input: DeleteInviteInput!) {
        deleteInvite(input: $input) {
          __typename
          id
          userId
          companyId
          inviteeEmail
          inviterEmail
          associatedCompanies
          status
          statusUpdatedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input,
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <DeleteInviteMutation>response.data.deleteInvite;
  }

  async GetInvite(id: string): Promise<GetInviteQuery> {
    const statement = `query GetInvite($id: ID!) {
        getInvite(id: $id) {
          __typename
          id
          userId
          companyId
          inviteeEmail
          inviterEmail
          associatedCompanies
          status
          statusUpdatedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id,
    };
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <GetInviteQuery>response.data.getInvite;
  }

  async ListInvites(
    filter?: ModelInviteFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<ListInvitesQuery> {
    const statement = `query ListInvites($filter: ModelInviteFilterInput, $limit: Int, $nextToken: String) {
        listInvites(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            userId
            companyId
            inviteeEmail
            inviterEmail
            associatedCompanies
            status
            statusUpdatedAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <ListInvitesQuery>response.data.listInvites;
  }

  async InvitesByUserId(
    userId: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelInviteFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<InvitesByUserIdQuery> {
    const statement = `query InvitesByUserId($userId: ID!, $sortDirection: ModelSortDirection, $filter: ModelInviteFilterInput, $limit: Int, $nextToken: String) {
        invitesByUserId(
          userId: $userId
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            userId
            companyId
            inviteeEmail
            inviterEmail
            associatedCompanies
            status
            statusUpdatedAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userId,
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <InvitesByUserIdQuery>response.data.invitesByUserId;
  }

  async InvitesByCompanyId(
    companyId: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelInviteFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<InvitesByCompanyIdQuery> {
    const statement = `query InvitesByCompanyId($companyId: ID!, $sortDirection: ModelSortDirection, $filter: ModelInviteFilterInput, $limit: Int, $nextToken: String) {
        invitesByCompanyId(
          companyId: $companyId
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            userId
            companyId
            inviteeEmail
            inviterEmail
            associatedCompanies
            status
            statusUpdatedAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      companyId,
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <InvitesByCompanyIdQuery>response.data.invitesByCompanyId;
  }

  async InvitesByInviteeEmail(
    inviteeEmail: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelInviteFilterInput,
    limit?: number,
    nextToken?: string,
  ): Promise<InvitesByInviteeEmailQuery> {
    const statement = `query InvitesByInviteeEmail($inviteeEmail: String!, $sortDirection: ModelSortDirection, $filter: ModelInviteFilterInput, $limit: Int, $nextToken: String) {
        invitesByInviteeEmail(
          inviteeEmail: $inviteeEmail
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          __typename
          items {
            __typename
            id
            userId
            companyId
            inviteeEmail
            inviterEmail
            associatedCompanies
            status
            statusUpdatedAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      inviteeEmail,
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await this.client.graphql({
      query: statement,
      variables: gqlAPIServiceArguments,
    })) as any;
    return <InvitesByInviteeEmailQuery>response.data.invitesByInviteeEmail;
  }
}
